import { j as o } from "../../../jsx-runtime-82a9ddf6.js";
const t = () => /* @__PURE__ */ o.jsxs("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ o.jsx("path", { d: "M4 6H20", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ o.jsx("path", { d: "M4 12H20", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ o.jsx("path", { d: "M4 18H20", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })
] });
export {
  t as MenuIcon
};
